<template>
  <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>Facebook</title>
    <path
      d="M12 0C5.372 0 0 5.4 0 12.061c0 6.048 4.432 11.04 10.206 11.912v-8.716h-2.97v-3.17h2.97v-2.11c0-3.493 1.693-5.025 4.582-5.025 1.382 0 2.114.103 2.46.15v2.767h-1.97c-1.225 0-1.653 1.169-1.653 2.486v1.733h3.593l-.487 3.17h-3.106V24C19.482 23.2 24 18.167 24 12.061 24 5.4 18.628 0 12 0z"
      fill-rule="evenodd"
    />
  </svg>
</template>
